// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PAfW","buttons":"styles_buttons__3d2fB"};